import { UserPreferences, UserProfile } from "../store/types";
import { useDispatch } from "react-redux";
import { syncUserPreferences, syncUserProfile, syncUserName } from "../store";

// // // //

type SyncUserProfileFunction = (profile: UserProfile) => void;
type SyncUserPreferencesFunction = (preferences: UserPreferences) => void;
type SyncUserNameFunction = (name: string) => void;

/**
 * useSyncUserProfile
 * React Hook that exposes User redux state
 */
export function useSyncUserSettings(): {
    syncProfile: SyncUserProfileFunction;
    syncPreferences: SyncUserPreferencesFunction;
    syncName: SyncUserNameFunction;
} {
    const dispatch = useDispatch();

    return {
        syncProfile: (profile: UserProfile) => {
            dispatch(syncUserProfile(profile));
        },
        syncPreferences: (preferences: UserPreferences) => {
            dispatch(syncUserPreferences(preferences));
        },
        syncName: (name: string) => {
            dispatch(syncUserName(name));
        },
    };
}
